module.exports = __webpack_public_path__ + "static/img/drawBtn.b9bb1fef.png";